import { render, staticRenderFns } from "./CheckBoxChoice.vue?vue&type=template&id=0c5920ed&scoped=true&"
import script from "./CheckBoxChoice.vue?vue&type=script&lang=js&"
export * from "./CheckBoxChoice.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxChoice.vue?vue&type=style&index=0&id=0c5920ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5920ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VLayout,VListItem,VListItemContent,VRow})
